import(/* webpackMode: "eager" */ "/app/app/about/page.tsx");
